<template>
  <div v-if="availableTabs.length" class="genetic-trials">
    <div class="highlights columns has-text-weight-medium">
      <div class="column certificate is-flex is-align-items-center mb-2">
        <DnaIcon />
        <span class="ml-4">Avaliação Genética</span>
      </div>
    </div>

    <div class="tabs is-small mb-0">
      <ul>
        <li
          v-for="tab in availableTabs"
          :key="tab.key"
          :class="{ 'is-active': activeTab === tab.key }"
        >
          <a @click.prevent="activeTab = tab.key">{{ tab.label }}</a>
        </li>
      </ul>
    </div>

    <div class="genetic-trials-table">
      <div class="gtr-row gtr-header">
        <div>Característica</div>
        <div v-for="col in activeColumns" :key="col.key">{{ col.label }}</div>
      </div>
      <div v-for="trial in activeTrials" :key="trial.name" class="gtr-row">
        <div class="has-text-weight-semibold">{{ trial.name }}</div>
        <div v-for="col in activeColumns" :key="col.key">
          {{ trial[col.key] ?? '—' }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.genetic-trials-table {
  width: 100%;
  border-radius: 6px;
  overflow: hidden;
}

.gtr-row {
  display: grid;
  grid-template-columns: 2fr repeat(2, 1fr);
  padding: 0.6rem 0.75rem;
  font-size: 0.875rem;
}

.gtr-row:nth-child(even) {
  background-color: #eee9e4;
}

.gtr-header {
  background-color: #eee9e4;
  font-weight: 600;
  border-bottom: 1px solid #ddd8d3;
}
</style>

<script>
import { ref, computed } from "vue";
import DnaIcon from "icons/cached/dna.svg";

const TAB_CONFIG = {
  abcz: {
    key: "abcz",
    label: "ABCZ",
    dataKey: "abcz_genetic_trials",
    columns: [
      { key: "dep",  label: "DEP"  },
      { key: "deca", label: "DECA" },
    ],
  },
  ancp: {
    key: "ancp",
    label: "ANCP",
    dataKey: "ancp_genetic_trials",
    columns: [
      { key: "mgte", label: "MGTe" },
      { key: "top",  label: "TOP"  },
    ],
  },
  geneplus: {
    key: "geneplus",
    label: "Geneplus",
    dataKey: "geneplus_genetic_trials",
    columns: [
      { key: "dep", label: "IQG" },
      { key: "top", label: "TOP" },
    ],
  },
};

export default {
  components: { DnaIcon },
  props: {
    animal: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const availableTabs = computed(() =>
      Object.values(TAB_CONFIG).filter(
        (tab) => props.animal[tab.dataKey]?.length > 0
      )
    );

    const selectedTab = ref(null);

    const activeTab = computed({
      get: () => selectedTab.value ?? availableTabs.value[0]?.key,
      set: (val) => { selectedTab.value = val; },
    });

    const activeConfig = computed(() => TAB_CONFIG[activeTab.value]);

    const activeTrials = computed(() => props.animal[activeConfig.value?.dataKey] ?? []);

    const activeColumns = computed(() => activeConfig.value?.columns ?? []);

    return {
      availableTabs,
      activeTab,
      activeTrials,
      activeColumns,
    };
  },
};
</script>
